<template>
  <div class="home-section-skeleton" :class="`home-section-skeleton--${variant}`" aria-hidden="true">
    <span v-for="item in count" :key="item" class="home-section-skeleton__item"></span>
  </div>
</template>

<script>
export default {
  name: "HomeSectionSkeleton",
  props: {
    count: { type: Number, default: 5 },
    variant: { type: String, default: "cards" },
  },
};
</script>
